<template>
  <transition name="slide-fade" >

    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              Broaden your knowledge while you are here with one of our minors.
            </p>
          </div>
        </div>
        <div class="uk-background-muted  uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <div class="uk-alert-primary uk-padding-small uk-margin-top uk-border-rounded"  uk-alert>

              <p class="uk-text-center">Please contact your department and advisor to ensure the minor is best for your career choice
                <br>
                <span class="uk-text-center"><a href="#deps" class="uk-link-text uk-text-small uk-text-muted"  uk-scroll="offset: 300px; duration: 2000">See department abbreviations</a></span>
              </p>
            </div>
            <div class="uk-overflow-auto">
              <table class="uk-table  uk-table-divider ">
                <thead>
                <tr>
                  <th > <h3 style="color: rgb(197,179,88) !important;" class="uk-heading-bullet specHeading">List of Possible Minors Offered</h3></th>
                  <th class="uk-table-shrink">Department</th>
                </tr>
                </thead>
                <tbody class="">
                <tr >
                  <td>Business Administration</td>
                  <td class="uk-text-center">BHM</td>
                </tr>
                <tr>
                  <td>Hospitality and Tourism Management</td>
                  <td class="uk-text-center">BHM</td>
                </tr>
                <tr>
                  <td>Conflict Analysis, Management, and Resolution </td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Corrections and Rehabilitation </td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Family Life Education </td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Forensic Sciences</td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Guidance Counselling </td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Law </td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Law and Political Science </td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Law Enforcement</td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Political Science and Government</td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Psychology</td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Sociology</td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Telephone Hotline Counselling</td>
                  <td class="uk-text-center">BSS</td>
                </tr>
                <tr>
                  <td>Communication Studies</td>
                  <td class="uk-text-center">COMM</td>
                </tr>
                <tr>
                  <td>English</td>
                  <td class="uk-text-center">HUM</td>
                </tr>
                <tr>
                  <td>French</td>
                  <td class="uk-text-center">HUM</td>
                </tr>
                <tr>
                  <td>History</td>
                  <td class="uk-text-center">HUM</td>
                </tr>
                <tr>
                  <td>Social Studies</td>
                  <td class="uk-text-center">HUM</td>
                </tr>
                <tr>
                  <td>Spanish</td>
                  <td class="uk-text-center">HUM</td>
                </tr>
                <tr>
                  <td>Music</td>
                  <td class="uk-text-center">HUM</td>
                </tr>
                <tr>
                  <td>Art</td>
                  <td class="uk-text-center">MFA</td>
                </tr>
                <tr>
                  <td>Biology</td>
                  <td class="uk-text-center">BCES</td>
                </tr>
                <tr>
                  <td>Chemistry</td>
                  <td class="uk-text-center">BCES</td>
                </tr>
                 <tr>
                  <td>Environmental Science</td>
                   <td class="uk-text-center">BCES</td>
                </tr>
                 <tr>
                  <td>Computer Information Systems</td>
                   <td class="uk-text-center">CIS</td>
                </tr>
                 <tr>
                  <td>Food and Nutrition</td>
                   <td class="uk-text-center">DNFS</td>
                </tr>

                </tbody>
              </table>
            </div>
            <h3 id="deps" class="uk-heading-bullet specHeading uk-margin-remove-bottom">Departments</h3>
            <div class="uk-child-width-1-2@m uk-padding uk-padding-remove-vertical" uk-grid>
              <div class=" uk-padding-small uk-margin-top uk-border-rounded uk-text-small uk-text-muted" >
                <p class="">BHM - Department of Business and Hospitality Management </p>
                <p class="">BSS - Department of Behavioural and Social Sciences </p>
                <p class="">COMM - Department of Communication Studies </p>
                <p class="">HUM - Department of Humanities </p>

              </div>
              <div class=" uk-padding-small uk-margin-top uk-border-rounded uk-text-small uk-text-muted" >
                <p class="">MFA - Department of Music and Fine Arts </p>
                <p class="">BCES - Department of Biology, Chemistry and Environmental Sciences </p>
                <p class="">CIS - Department of Computer and Information Science</p>
                <p class="">DNFS - Department of Dietetics, Nutrition and Food Science</p>
              </div>
            </div>
            <br><br>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
    export default {
        name: "minors",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Minors Offerings',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Minors that are offered to students at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>

</style>
